import { $ } from "dom7";
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

export function initSliderPromo() {
  const promoSlides = $(".promo.swiper .swiper-slide");
  if (promoSlides.length > 1) {
    /* my code*/
    new Swiper(".promo", {
      modules: [Navigation, Pagination, Autoplay],
      speed: 1500,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
      },
      speed: 4000,
      loop: true,
      watchSlidesProgress: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        dynamicBullets: false,

        type: "bullets",
      },

      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1150: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      },
    });
  }
}
